import { useContext } from "react";
import styles from "./styles.module.css";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { formatName } from "../formatName";
import DeleteIcon from "../../../images/svg/trash.svg";
import ShopContext from "context/ShopContext";
import { roundOff, amountRoundOff } from "helpers/NumberFormatHelper";
import { DEFAULT_PRODUCT_IMAGE } from "const";
import ProductPlaceholder from "images/product-placeholder.png";
import SalesContext from "context/SalesContext";

function CartItem({ saleItem, onCartItemClick, index }) {
  const { selectedShop } = useContext(ShopContext);
  const { increaseSaleItemInActiveSale, reduceSaleItemFromActiveSale, removeSaleItemFromActiveSale } =
    useContext(SalesContext);

  const product = saleItem?.item ?? {};

  const handleImageError = (e) => {
    e.target.src = ProductPlaceholder;
  };

  return (
    <div
      className={styles.cartItem}
      onClick={() => {
        onCartItemClick?.(saleItem);
      }}
    >
      <div className={styles.cartItemImgWrapper}>
        <img
          src={product?.image && product.image !== DEFAULT_PRODUCT_IMAGE ? product.image : ProductPlaceholder}
          alt={product?.name || "img"}
          className={styles.cartItemImg}
          onError={handleImageError}
        />
      </div>

      <div className={styles.serialNumber}>{index + 1}</div>

      <div className={styles.cartItemInfo}>
        <div className={styles.itemHeader}>
          <h5 className={styles.itemName}>
            {formatName(product?.name)} {saleItem?.option?.label ? `- ${saleItem?.option?.label}` : ""}
          </h5>
          <img
            src={DeleteIcon}
            alt="delete"
            className={styles.deleteIcon}
            onClick={(e) => {
              e.stopPropagation();
              removeSaleItemFromActiveSale(saleItem?.localId);
            }}
          />
        </div>

        <div className={styles.stockInfo}>
          <span>
            Stock: {product?.stock} {product?.unit}
          </span>
          <span className={styles.bar}>|</span>
          <span>
            {saleItem?.option ? saleItem.option.quantity_ratio : 1} {product?.unit} @ {selectedShop?.currency_symbol}{" "}
            {roundOff(saleItem?.rate ?? 0)}
          </span>
        </div>

        {saleItem?.discount ? (
          <div className={styles.discountInfo}>
            Discount: {selectedShop?.currency_symbol} {saleItem.discount}
            {saleItem?.discountPercentage ? ` (${amountRoundOff(saleItem.discountPercentage)}%)` : ""}
          </div>
        ) : null}

        {saleItem?.totalCharges ? (
          <div className={styles.discountInfo}>
            Charges: {selectedShop?.currency_symbol} {roundOff(saleItem.totalCharges)}
          </div>
        ) : null}

        {saleItem?.note ? <div className={styles.discountInfo}> {saleItem.note}</div> : null}

        <div className={styles.cartItemMeta}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div className={styles.rupeeIcon}>{selectedShop?.currency_symbol}</div>
            <div className={styles.itemPrice}>{roundOff(saleItem?.payable ?? 0)}</div>
          </div>

          <div className={styles.addCartWrapper}>
            <button
              className={styles.qtyBtn}
              onClick={(e) => {
                e.stopPropagation();
                reduceSaleItemFromActiveSale(saleItem?.localId);
              }}
              aria-label="decrease"
            >
              <RemoveIcon style={{ fontSize: 16 }} />
            </button>
            <div className={styles.qtyText}>{roundOff(saleItem?.qty ?? 0)}</div>
            <button
              className={styles.qtyBtn}
              onClick={(e) => {
                e.stopPropagation();
                increaseSaleItemInActiveSale(saleItem?.localId);
              }}
              aria-label="increase"
            >
              <AddIcon style={{ fontSize: 16 }} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CartItem;
